import React from 'react';

export default class Objective extends React.Component {
  render() {
    return <div className="content">
      <h1 className="title is-3">Agree on Treatment Objective</h1>
      <img src="/assets/images/step+2.jpeg" />
      <p>Reaching concordance, an agreement with the patient on a specific treatment objective, is important to establishing a therapeutic alliance.</p>
      <p>Treatment can proceed, if patient and clinician agree about the goal of treatment and an intervention with an acceptable risk:benefit ratio.</p>
      <p>In most instances this agreement includes an agreement about the diagnosis, but agreement about a diagnostic label is not required. A diagnosis is an opinion about the cause of the problem. Differences in labeling a cause need not be an obstacle to intervention.</p>
      <p>An important part of a treatment agreement is the clinician’s duty to inform the patient of any “proven treatments” that may be available.</p>
    </div>;
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/more/Objective.js